import { useEffect, useState } from "react";
import axios from "axios";

export default function FinancePayoutScreen() {
  const [data, setData] = useState([]);
  const [loadingId, setLoadingId] = useState(null);
  const [payingId, setPayingId] = useState(null);

  const token = localStorage.getItem("token");

  // ==========================
  // LOAD DATA
  // ==========================
  const load = async () => {
    try {
      const res = await axios.get(
        "http://159.198.79.96:5000/api/finance/claims",
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      setData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    load();
  }, []);

  // ==========================
  // CREATE PAYOUT
  // ==========================
  const createPayout = async (id) => {
    try {
      setLoadingId(id);

      const res = await axios.post(
        "http://159.198.79.96:5000/api/finance/payout-single",
        { claim_id: id },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setData(prev =>
        prev.map(row =>
          row.id === id
            ? { ...row, payout_id: res.data.payout_id, payout_status: "pending" }
            : row
        )
      );
    } catch (err) {
      alert(err.response?.data?.msg || "Error");
    } finally {
      setLoadingId(null);
    }
  };

  // ==========================
  // MARK PAID
  // ==========================
  const markPaid = async (payoutId, claimId) => {
    try {
      setPayingId(claimId);

      await axios.post(
        `http://159.198.79.96:5000/api/finance/payout-paid/${payoutId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setData(prev =>
        prev.map(row =>
          row.id === claimId
            ? { ...row, payout_status: "paid" }
            : row
        )
      );
    } catch {
      alert("Error marking paid");
    } finally {
      setPayingId(null);
    }
  };

  // ==========================
  // TOTALS (DASHBOARD)
  // ==========================
  const total = data.reduce((s, r) => s + Number(r.claim_amount), 0);
  const paid = data
    .filter(r => r.payout_status === "paid")
    .reduce((s, r) => s + Number(r.claim_amount), 0);
  const pending = data
    .filter(r => r.payout_status !== "paid")
    .reduce((s, r) => s + Number(r.claim_amount), 0);

  // ==========================
  // UI
  // ==========================
  return (
    <div style={{ padding: 20 }}>

      <h2 style={{ marginBottom: 15 }}>💰 Finance Payouts</h2>

      {/* ================= CARDS ================= */}
      <div style={styles.cards}>
        <div style={styles.card}>💰 Total<br /><b>Rs. {total}</b></div>
        <div style={{ ...styles.card, background: "#27ae60" }}>
          ​✅​Paid<br /><b>Rs. {paid}</b>
        </div>
        <div style={{ ...styles.card, background: "#f39c12" }}>
          ⏳​Pending<br /><b>Rs. {pending}</b>
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div style={{ overflowX: "auto" }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th>Salesman</th>
              <th>Dealer</th>
              <th>Product Name</th>
              <th>Product Model</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {data.map(row => (
              <tr key={row.id}>
                <td>{row.salesman_name}</td>
                <td>{row.dealer_name}</td>
                <td>{row.product_name}</td>
                <td>{row.qr_value}</td>
                <td>Rs. {row.claim_amount}</td>

                <td>
                  {row.payout_status === "paid"
                    ? <span style={{ color: "green" }}>● Paid</span>
                    : row.payout_status === "pending"
                    ? <span style={{ color: "orange" }}>● Pending</span>
                    : <span style={{ color: "#555" }}>● Not Generated</span>}
                </td>

                <td>
                  {row.payout_status === "paid" ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      PAID ✅
                    </span>
                  ) : row.payout_status === "pending" ? (
                    <button
                      onClick={() => markPaid(row.payout_id, row.id)}
                      disabled={payingId === row.id}
                      style={styles.pendingBtn}
                    >
                      {payingId === row.id ? "Processing..." : "Mark Paid"}
                    </button>
                  ) : (
                    <button
                      onClick={() => createPayout(row.id)}
                      disabled={loadingId === row.id}
                      style={styles.generateBtn}
                    >
                      {loadingId === row.id ? "Processing..." : "Generate"}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

// ================= STYLES =================
const styles = {
  cards: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    marginBottom: 20
  },
  card: {
    flex: 1,
    minWidth: 150,
    padding: 15,
    background: "#2c5178",
    color: "#fff",
    borderRadius: 10,
    textAlign: "center"
  },
  table: {
    width: "100%",
    borderCollapse: "collapse"
  },
  generateBtn: {
    background: "#2c5178",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    borderRadius: 5
  },
  pendingBtn: {
    background: "orange",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    borderRadius: 5
  }
};